/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
  GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  GetApiV1AccesscontrolPermissionsSummary401,
  GetApiV1AccesscontrolPermissionsSummary500,
} from "../../types/accessControlPermissionsController/GetApiV1AccesscontrolPermissionsSummary.ts";

function getGetApiV1AccesscontrolPermissionsSummaryUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/accesscontrol/permissions/summary` as const,
  };
  return res;
}

/**
 * @description Retorna todos os controllers com os flags de permissão agregados para um role. Um flag é true se ao menos um usuário do role possuir aquela permissão no controller. **(Requer Authorization para autenticação)**
 * @summary Resumo de permissões por role (Requer Authorization para autenticação)
 * {@link /api/v1/accesscontrol/permissions/summary}
 */
export async function getApiV1AccesscontrolPermissionsSummary(
  params?: GetApiV1AccesscontrolPermissionsSummaryQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1AccesscontrolPermissionsSummaryQueryResponse,
    ResponseErrorConfig<
      | GetApiV1AccesscontrolPermissionsSummary401
      | GetApiV1AccesscontrolPermissionsSummary500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1AccesscontrolPermissionsSummaryUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
